
  import {
    defineComponent,
    ref,
    reactive,
    toRefs,
    inject,
    defineAsyncComponent,
    onMounted,
    nextTick,
  } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import * as _ from 'lodash';
  import { ErrorMessage, Field, Form } from 'vee-validate';


  export default defineComponent({
    name: 'FormRadioInput',
    components: {
      Field,
      ErrorMessage,
      FormBuilder: defineAsyncComponent(() =>
        import(/* webpackPrefetch: true */'./FormBuilder.vue'),
      ),
    },
    props: ['item', 'items', 'iterator'],
    setup(props, context) {
      const helpers: any = inject('helpers');
      const i18n = useI18n();

      const state = reactive({
        item: props.item,
        items: props.items,
        iterator: props.iterator,
      });

      onMounted(() => {
        if (state.item) state.item.value = (state.item.value) ? (state.item.value).toString() : null;
      });

      const triggerChange = (selection) => {
        let item: any = state.item;
        let iterator: any = state.iterator;
        let selected_value: any = JSON.parse(JSON.stringify((getSelectValue(item, selection))));


        // remove item
        let removalKeys: any = [];
        _.forEach(item.selection_values, (SV) => {
          let SECTION: any = SV?.section;
          // if (SECTION && SV.id != selected_value.id) {
            removalKeys.push(SECTION?.model_key);
          // }
        });
        _.remove(state.items, function(currentObject: any) {
          return removalKeys.includes(currentObject.model_key);
        });

        if (selected_value && selected_value.section) {
          setTimeout(()=>{
            state.items.splice(iterator + 1 , 0, cloneSection(selected_value.section));
          },100)
        }
        // if (selected_value.section) {
        //   let insertItem = insertAfterIndex(state.items, iterator, cloneSection(selected_value.section));
        //
        //   state.items.splice(0);
        //   _.forEach(insertItem, (item) => {
        //     state.items.push(item);
        //   });
        // }
      };

      const insertAfterIndex = (arr, index, newItem) => [
        ...arr.slice(0, index + 1),

        newItem,

        ...arr.slice(index + 1),
      ];

      const cloneSection = (section) => {
        let clonedSectionItem: any = Object.assign({}, section);
        clonedSectionItem.key = `_main_${Math.random().toString(16)}`;
        clonedSectionItem.section_repeat_index = 1;

        let itemsR: any = [];
        _.forEach(clonedSectionItem.items, (oldItem) => {
          // oldItem = JSON.parse(JSON.stringify(oldItem));
          oldItem.key = `_sub_${Math.random().toString(16)}`;
          oldItem.value = null;
          oldItem.values = [];
          if(oldItem.type != "Section") itemsR.push(oldItem);
        });
        return clonedSectionItem;
      };

      const getSelectValue = (item, val) => {
        let Gitem: any = null;
        _.forEach(item.selection_values, (_item) => {
          if (_item.id == val) {
            Gitem = _item;
            return;
          }
        });
        return Gitem;
      };

      return {
        ...toRefs(state),
        i18n,
        triggerChange,
        helpers,
        getSelectValue,
      };
    },
  });
